import { render, staticRenderFns } from "./LinkedSystemDetail.vue?vue&type=template&id=08c858cc&"
import script from "./LinkedSystemDetail.vue?vue&type=script&lang=js&"
export * from "./LinkedSystemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports